import { useQuery } from "@tanstack/react-query";
import { getBlogById } from "../../api/apiBlogs";

/**
 * Hook لجلب مدونة واحدة
 * @param {number|string} id - Blog ID
 */
export function useGetBlog(id) {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["blog", id],
        queryFn: () => getBlogById(id),
        enabled: !!id,
        retry: false,
    });

    const blog = data?.data || null;

    return { isLoading, error, blog, refetch };
}
